module.exports = __webpack_public_path__ + "static/media/Nigeria_flag.8f4cdcc0.svg";